import React from "react"

import StoryblokLink from "../shared/StoryblokLink"

import { renderCardHeadline } from "../contentEdit"

import { UseCaseContent } from "../../types"

type CaseStudyItemProps = {
  full_slug: string
  content: UseCaseContent
}

const CaseStudyItem = ({ full_slug, content }: CaseStudyItemProps) => {
  const linkObject = {
    cached_url: full_slug,
    linktype: "story",
  }

  const cardHeadline = renderCardHeadline(
    content?.header[0].pageTitle,
    "c-learnItem__heading"
  )

  return (
    <StoryblokLink to={linkObject} className="c-learnItem d-flex flex-column">
      <div className="c-learnItem__hoverWrapper">
        <div
          className="c-learnItem__imageWrapper"
          style={{
            backgroundImage: `url(${content?.header[0].cardBigThumb?.filename})`,
          }}
        />

        <div className="c-learnItem__content">
          <span className="c-learnItem__type">{content?.component}</span>

          {cardHeadline}

          <span className="btn-tertiary hover-bcgUnderline">Read more</span>
        </div>
      </div>
    </StoryblokLink>
  )
}

export default CaseStudyItem
